import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { StaffEditPayload } from '../../../models/StaffEdit';
import { StaffService } from '../../../services/staff.service';
import { DepartmentService } from '../../../services/department.service';
import { PositionService } from '../../../services/position.service';
import { Department } from '../../../models/Department';
import { Position } from '../../../models/Position';
import { environment } from 'src/environments/environment';
import { BENEFIT_TYPE_OPTIONS } from '../../../models/BenefitType';
import { CostCentersService } from '../../../services/cost-centers.service';
import { CostCenter } from '../../../models/CostCenter';
import { PermissionService } from '../../../services/permission.service';
import { ERPPermissions } from '../../../constants/permissions.constants';

@Component({
  selector: 'app-staff-form',
  templateUrl: './staff-form.component.html',
  styleUrls: ['./staff-form.component.css']
})
export class StaffFormComponent implements OnInit {
  
  loading = false;
  saving = false;
  error: string | null = null;
  successMessage: string | null = null;
  
  private readonly allTabs = [
    { id: 'basic', label: 'Dados Pessoais', icon: 'fas fa-user', required: true, completed: false },
    { id: 'contract', label: 'Contrato', icon: 'fas fa-file-contract', required: true, completed: false },
    { id: 'banking', label: 'Bancário', icon: 'fas fa-university', required: false, completed: false },
    { id: 'contacts', label: 'Contatos', icon: 'fas fa-phone', required: false, completed: false },
    { id: 'addresses', label: 'Endereços', icon: 'fas fa-map-marker-alt', required: false, completed: false },
    { id: 'salary', label: 'Salário', icon: 'fas fa-money-bill-wave', required: false, completed: false },
    { id: 'benefits', label: 'Benefícios', icon: 'fas fa-gift', required: false, completed: false },
    { id: 'documents', label: 'Documentos', icon: 'fas fa-paperclip', required: false, completed: false }
  ];
  availableTabs = this.allTabs.map(tab => ({ ...tab }));
  
  activeTab = 'basic';
  readonly Permissions = ERPPermissions;
  
  formData: StaffEditPayload = {
    staff: {
      fullName: '',
      registration: '',
      position: '',
      department: '',
      manager: null,
      hireDate: new Date().toISOString(),
      contractType: 'CLT',
      cpf: '',
      isForeigner: false,
      passportNumber: '',
      rg: '',
      rgIssuingAuthority: '',
      rgIssueDate: '',
      birthDate: '',
      gender: 'M',
      maritalStatus: 'Solteiro',
      motherName: '',
      fatherName: '',
      hasDisability: false,
      nationality: 'Brasileira',
      birthPlace: '',
      shift: 'Diurno',
      workSchedule: '08:00-17:00',
      unit: ''
    },
    contract: {
      contractType: 'CLT',
      startDate: new Date().toISOString(),
      endDate: null,
      notes: null,
      cnpj: '',
      companyName: '',
      tradeName: '',
      companyAddress: '',
      stateRegistration: '',
      municipalRegistration: '',
      companyEmail: '',
      companyPhone: '',
      costCenter: null
    },
    contacts: [],
    addresses: [],
    salary: {
      baseSalary: null,
      grossSalary: null,
      netSalary: null,
      currency: 'BRL',
      salaryType: 'Mensal',
      notes: ''
    } as any,
    benefits: [],
    attachments: []
  };

  private uploadedFiles: { [key: string]: File | null } = {};
  uploadProgress: { [key: string]: number } = {};
  uploadStatus: { [key: string]: 'pending' | 'uploading' | 'success' | 'error' } = {};
  uploadedDocuments: { [key: string]: any } = {};

  readonly DOCUMENT_TYPES = [
    { value: 'photo', label: 'Foto do Perfil', icon: 'fas fa-camera', endpoint: 'upload-photo' },
    { value: 'rg', label: 'RG', icon: 'fas fa-id-card', endpoint: 'upload-document' },
    { value: 'cpf', label: 'CPF', icon: 'fas fa-id-card', endpoint: 'upload-document' },
    { value: 'cnh', label: 'CNH', icon: 'fas fa-id-card', endpoint: 'upload-document' },
    { value: 'workCard', label: 'Carteira de Trabalho', icon: 'fas fa-id-card', endpoint: 'upload-document' },
    { value: 'diploma', label: 'Diploma', icon: 'fas fa-graduation-cap', endpoint: 'upload-document' },
    { value: 'curriculum', label: 'Currículo', icon: 'fas fa-file-alt', endpoint: 'upload-document' },
    { value: 'residenceProof', label: 'Comprovante de Residência', icon: 'fas fa-home', endpoint: 'upload-document' },
    { value: 'medicalCertificate', label: 'Atestado Médico', icon: 'fas fa-heartbeat', endpoint: 'upload-document' }
  ];

  readonly OTHER_DOCUMENT_TYPE = { value: 'other', label: 'Outros Documentos', icon: 'fas fa-folder-open', endpoint: 'upload-document' };
  otherDocuments: any[] = [];

  readonly SHIFT_OPTIONS = [
    { value: 'Diurno', label: 'Diurno' },
    { value: 'Noturno', label: 'Noturno' },
    { value: 'Integral', label: 'Integral' }
  ];

  readonly WORK_START_OPTIONS = [
    { value: '05:00', label: '05:00' },
    { value: '06:00', label: '06:00' },
    { value: '07:00', label: '07:00' },
    { value: '08:00', label: '08:00' },
    { value: '09:00', label: '09:00' },
    { value: '10:00', label: '10:00' },
    { value: '11:00', label: '11:00' },
    { value: '12:00', label: '12:00' },
    { value: '13:00', label: '13:00' },
    { value: '14:00', label: '14:00' },
    { value: '15:00', label: '15:00' },
    { value: '16:00', label: '16:00' },
    { value: '17:00', label: '17:00' },
    { value: '18:00', label: '18:00' },
    { value: '19:00', label: '19:00' },
    { value: '20:00', label: '20:00' },
    { value: '21:00', label: '21:00' },
    { value: '22:00', label: '22:00' },
    { value: '23:00', label: '23:00' },
    { value: '00:00', label: '00:00' }
  ];

  readonly BANKS_OPTIONS = [
    { value: '001', label: '001 - Banco do Brasil S.A.' },
    { value: '104', label: '104 - Caixa Econômica Federal' },
    { value: '341', label: '341 - Itaú Unibanco S.A.' },
    { value: '237', label: '237 - Banco Bradesco S.A.' },
    { value: '033', label: '033 - Banco Santander (Brasil) S.A.' },
    { value: '260', label: '260 - Nubank (Nu Pagamentos)' },
    { value: '077', label: '077 - Banco Inter' },
    { value: '336', label: '336 - C6 Bank' },
    { value: '290', label: '290 - PagBank (PagSeguro)' },
    { value: '323', label: '323 - Mercado Pago' },
    { value: '380', label: '380 - PicPay' },
    { value: '422', label: '422 - Banco Safra S.A.' },
    { value: '756', label: '756 - Banco Cooperativo do Brasil (Bancoob)' },
    { value: '748', label: '748 - Sicredi' },
    { value: '041', label: '041 - Banrisul' },
    { value: '004', label: '004 - Banco do Nordeste do Brasil S.A.' },
    { value: '021', label: '021 - Banco do Estado do Espírito Santo S.A.' },
    { value: '047', label: '047 - Banco do Estado de Sergipe S.A.' },
    { value: '085', label: '085 - Ailos - Sistema de Cooperativas de Crédito' },
    { value: '097', label: '097 - Credisis - Central de Cooperativas de Crédito' },
    { value: '136', label: '136 - Unicred Central' },
    { value: '212', label: '212 - Banco Original' },
    { value: '218', label: '218 - Banco BS2' },
    { value: '222', label: '222 - Banco Credit Agricole Brasil S.A.' },
    { value: '224', label: '224 - Banco Fibra S.A.' },
    { value: '233', label: '233 - Banco Cifra' },
    { value: '318', label: '318 - Banco BMG S.A.' },
    { value: '356', label: '356 - Banco Real S.A.' },
    { value: '389', label: '389 - Banco Mercantil do Brasil' },
    { value: '399', label: '399 - HSBC Bank Brasil S.A.' },
    { value: '637', label: '637 - Banco Sofisa S.A.' },
    { value: '652', label: '652 - Itaú Unibanco Holding S.A.' },
    { value: '745', label: '745 - Banco Citibank S.A.' },
    { value: '000', label: '000 - Outro (Especificar)' }
  ];

  readonly ACCOUNT_TYPE_OPTIONS = [
    { value: 'Corrente', label: 'Conta Corrente' },
    { value: 'Poupanca', label: 'Conta Poupança' },
    { value: 'Salario', label: 'Conta Salário' },
    { value: 'Pagamento', label: 'Conta de Pagamento' },
    { value: 'Outro', label: 'Outro' }
  ];

  readonly BENEFIT_TYPE_OPTIONS = BENEFIT_TYPE_OPTIONS;

  departments: Department[] = [];
  positions: Position[] = [];
  selectedDepartmentId: number | null = null;
  isLoadingDepartments = false;
  isLoadingPositions = false;

  // Unidades e centros de custo
  readonly UNIT_OPTIONS = [
    { value: 'Matriz Santa Marina', label: 'Matriz Santa Marina' },
    { value: 'Matriz Butantã', label: 'Matriz Butantã' }
  ];

  costCenters: CostCenter[] = [];
  isLoadingCostCenters = false;

  constructor(
    private router: Router,
    private staffService: StaffService,
    private departmentService: DepartmentService,
    private positionService: PositionService,
    private cdr: ChangeDetectorRef,
    private costCentersService: CostCentersService,
    private permissionService: PermissionService
  ) { 
    this.formData.contacts = [];
  }

  ngOnInit(): void {
    this.applySalaryPermissionTabs();
    this.applyContractTypeTabRules();
    if (!this.formData.contacts) {
      this.formData.contacts = [];
    }
    this.initializeEmptyContacts();
    this.initializeEmptyAddresses();
    this.initializeEmptyBanking();
    this.loadCostCenters();
    this.updateTabsCompletionStatus();
  }

  private applySalaryPermissionTabs(): void {
    const canViewSalary = this.permissionService.hasPermission(this.Permissions.VISUALIZAR_SALARIO);
    if (canViewSalary) {
      return;
    }

    this.availableTabs = this.availableTabs.filter(tab => tab.id !== 'salary' && tab.id !== 'benefits');
    if (this.activeTab === 'salary' || this.activeTab === 'benefits') {
      this.activeTab = this.availableTabs[0]?.id || 'basic';
    }
  }

  onContractTypeChange(contractType: string): void {
    this.formData.contract.contractType = contractType;
    this.applyContractTypeTabRules();
    this.updateTabsCompletionStatus();
  }

  private applyContractTypeTabRules(): void {
    const canViewSalary = this.permissionService.hasPermission(this.Permissions.VISUALIZAR_SALARIO);
    const isPJ = this.formData.contract?.contractType === 'PJ';

    this.availableTabs = this.allTabs
      .filter(tab => {
        if (!canViewSalary && (tab.id === 'salary' || tab.id === 'benefits')) return false;
        if (isPJ && tab.id === 'benefits') return false;
        return true;
      })
      .map(tab => ({ ...tab }));

    if (!this.availableTabs.some(tab => tab.id === this.activeTab)) {
      this.activeTab = this.availableTabs[0]?.id || 'basic';
    }
  }

  selectTab(tabId: string): void {
    this.activeTab = tabId;
    if (tabId === 'benefits') {
      this.initializeEmptyBenefits();
    }
    if (tabId === 'contract') {
      this.loadDepartments();
    }
  }

  getCurrentTabIndex(): number {
    return this.availableTabs.findIndex(tab => tab.id === this.activeTab);
  }

  isFirstTab(): boolean {
    return this.getCurrentTabIndex() === 0;
  }

  isLastTab(): boolean {
    return this.getCurrentTabIndex() === this.availableTabs.length - 1;
  }

  goToNextTab(): void {
    if (this.isTabValid(this.activeTab)) {
      const currentTab = this.availableTabs.find(tab => tab.id === this.activeTab);
      if (currentTab) {
        currentTab.completed = true;
      }
      const currentIndex = this.getCurrentTabIndex();
      if (currentIndex < this.availableTabs.length - 1) {
        this.activeTab = this.availableTabs[currentIndex + 1].id;
        this.selectTab(this.activeTab); // Chamar selectTab para garantir carregamento de dados
      }
      this.updateTabsCompletionStatus();
    } else {
      alert('Por favor, preencha todos os campos obrigatórios desta aba antes de prosseguir.');
    }
  }

  goToPreviousTab(): void {
    const currentIndex = this.getCurrentTabIndex();
    if (currentIndex > 0) {
      this.activeTab = this.availableTabs[currentIndex - 1].id;
    }
  }

  initializeEmptyContacts(): void {
    if (this.formData.contacts.length === 0) {
      const userContact = {
        contactType: 'Telefone',
        contactName: '',
        phoneNumber: '',
        relationship: 'Próprio',
        isEmergencyContact: false,
        isDefault: true
      };
      const emergencyContact = {
        contactType: 'Telefone',
        contactName: '',
        phoneNumber: '',
        relationship: 'Familiar',
        isEmergencyContact: true,
        isDefault: false
      };
      this.formData.contacts.push(userContact);
      this.formData.contacts.push(emergencyContact);
    }
  }

  loadCostCenters(): void {
    this.isLoadingCostCenters = true;
    // Usa a mesma paginação padrão das telas financeiras (page=1, pageSize=50)
    this.costCentersService.getAll({ page: 1, pageSize: 50 }).subscribe({
      next: (result) => {
        this.costCenters = result.items || [];
        this.isLoadingCostCenters = false;
      },
      error: () => {
        this.isLoadingCostCenters = false;
      }
    });
  }

  initializeEmptyAddresses(): void {
    if (this.formData.addresses.length === 0) {
      this.formData.addresses.push({
        addressType: 'Residencial',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
        zipCode: '',
        country: 'Brasil',
        isDefault: true
      });
    }
  }

  initializeEmptyBanking(): void {}

  initializeEmptyBenefits(): void {
    if (!this.formData.benefits || this.formData.benefits.length === 0) {
      this.formData.benefits = [{
        benefitType: '',
        amount: null as any,
        currency: 'BRL',
        startDate: new Date().toISOString(),
        isActive: true
      }];
    }
  }

  addContact(): void {
    this.formData.contacts.push({
      contactType: 'Telefone',
      contactName: '',
      phoneNumber: '',
      relationship: 'Familiar',
      isEmergencyContact: true,
      isDefault: false
    });
    this.updateTabsCompletionStatus();
  }

  removeContact(index: number): void {
    if (index === 0) {
      alert('O primeiro contato (do usuário) não pode ser removido!');
      return;
    }
    if (index === 1) {
      alert('O segundo contato (de emergência) não pode ser removido!');
      return;
    }
    if (this.formData.contacts.length > 2) {
      this.formData.contacts.splice(index, 1);
      this.updateTabsCompletionStatus();
    } else {
      alert('É necessário manter pelo menos 2 contatos: um do usuário e um de emergência!');
    }
  }

  addAddress(): void {
    this.formData.addresses.push({
      addressType: 'Residencial',
      street: '',
      number: '',
      complement: '',
      neighborhood: '',
      city: '',
      state: '',
      zipCode: '',
      country: 'Brasil',
      isDefault: false
    });
    this.updateTabsCompletionStatus();
  }

  removeAddress(index: number): void {
    if (this.formData.addresses.length > 1) {
      this.formData.addresses.splice(index, 1);
      this.updateTabsCompletionStatus();
    }
  }

  addBanking(): void {}

  removeBanking(index: number): void {}

  addBenefit(): void {
    if (!this.formData.benefits) {
      this.formData.benefits = [];
    }
    this.formData.benefits.push({
      benefitType: '',
      amount: null as any,
      currency: 'BRL',
      startDate: new Date().toISOString(),
      isActive: true
    });
    this.updateTabsCompletionStatus();
  }

  removeBenefit(index: number): void {
    if (this.formData.benefits && this.formData.benefits.length > 1) {
      this.formData.benefits.splice(index, 1);
      this.updateTabsCompletionStatus();
    }
  }

  loadDepartments(): void {
    if (this.departments.length > 0) return;
    this.isLoadingDepartments = true;
    this.departmentService.getAllDepartments().subscribe({
      next: (list) => {
        this.departments = list || [];
        this.isLoadingDepartments = false;
      },
      error: () => {
        this.isLoadingDepartments = false;
      }
    });
  }

  onDepartmentChange(departmentName: string): void {
    const department = this.departments.find(d => d.name === departmentName);
    if (department) {
      this.selectedDepartmentId = department.id;
      this.formData.staff.manager = department.managerStaffName || null;
      (this.formData.staff as any).managerId = department.managerStaffId ?? null;
      this.loadPositionsByDepartment(department.id);
    } else {
      this.selectedDepartmentId = null;
      this.formData.staff.manager = null;
      (this.formData.staff as any).managerId = null;
      this.positions = [];
    }
  }

  loadPositionsByDepartment(departmentId: number): void {
    this.isLoadingPositions = true;
    this.positions = [];
    this.positionService.getPositionsByDepartment(departmentId).subscribe({
      next: (response) => {
        this.positions = response.positions || [];
        this.isLoadingPositions = false;
        if (this.formData.staff.position && !this.positions.find(p => p.name === this.formData.staff.position)) {
          this.formData.staff.position = '';
        }
      },
      error: () => {
        this.positions = [];
        this.isLoadingPositions = false;
      }
    });
  }

  getInputValue(event: Event): string {
    return (event.target as HTMLInputElement).value;
  }

  getSelectValue(event: Event): string {
    return (event.target as HTMLSelectElement).value;
  }

  onForeignerChange(): void {
    if (this.formData.staff.isForeigner) {
      this.formData.staff.cpf = '';
    } else {
      this.formData.staff.passportNumber = '';
    }
  }

  applyAgencyMask(event: Event): void {
    const input = event.target as HTMLInputElement;
    // Permite letras e numeros (ex.: 1234-X), removendo apenas caracteres nao suportados
    const value = (input.value || '')
      .toUpperCase()
      .replace(/[^A-Z0-9-]/g, '')
      .slice(0, 10);
    input.value = value;
    this.formData.staff.agency = value;
  }

  applyAccountNumberMask(event: Event): void {
    const input = event.target as HTMLInputElement;
    // Permite letras e numeros (ex.: 12345-X), removendo apenas caracteres nao suportados
    const value = (input.value || '')
      .toUpperCase()
      .replace(/[^A-Z0-9-]/g, '')
      .slice(0, 20);
    input.value = value;
    this.formData.staff.accountNumber = value;
  }

  applyPhoneMaskToContact(event: Event, contact: any): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');
    if (contact.contactType === 'Celular' || contact.contactType === 'WhatsApp') {
      if (value.length <= 2) {
        input.value = value;
      } else if (value.length <= 7) {
        input.value = '(' + value.substring(0, 2) + ') ' + value.substring(2);
      } else {
        input.value = '(' + value.substring(0, 2) + ') ' + value.substring(2, 7) + '-' + value.substring(7, 11);
      }
    } else if (contact.contactType === 'Telefone') {
      if (value.length <= 2) {
        input.value = value;
      } else if (value.length <= 6) {
        input.value = '(' + value.substring(0, 2) + ') ' + value.substring(2);
      } else {
        input.value = '(' + value.substring(0, 2) + ') ' + value.substring(2, 6) + '-' + value.substring(6, 10);
      }
    }
    contact.phoneNumber = input.value;
  }

  getContactLabel(contactType: string): string {
    switch (contactType) {
      case 'Email': return 'Email';
      case 'Telefone': return 'Telefone';
      case 'Celular': return 'Celular';
      case 'WhatsApp': return 'WhatsApp';
      default: return 'Telefone';
    }
  }

  getContactPlaceholder(contactType: string): string {
    switch (contactType) {
      case 'Email': return 'email@exemplo.com';
      case 'Telefone': return '(00) 0000-0000';
      case 'Celular': return '(00) 00000-0000';
      case 'WhatsApp': return '(00) 00000-0000';
      default: return 'Telefone';
    }
  }

  onContactTypeChange(contact: any): void {
    if (contact.contactType !== 'Email' && contact.phoneNumber && !contact.phoneNumber.includes('@')) {
      const fakeEvent = { target: { value: contact.phoneNumber.replace(/\D/g, '') } } as any;
      this.applyPhoneMaskToContact(fakeEvent, contact);
    }
  }

  getDocumentName(docType: string): string {
    return this.uploadedDocuments[docType]?.documentName || this.DOCUMENT_TYPES.find(dt => dt.value === docType)?.label || '';
  }

  setDocumentName(docType: string, name: string): void {
    if (!this.uploadedDocuments[docType]) {
      this.uploadedDocuments[docType] = {};
    }
    this.uploadedDocuments[docType].documentName = name;
  }

  applyCNPJMask(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');
    if (value.length <= 14) {
      value = value.replace(/^(\d{2})(\d)/, '$1.$2');
      value = value.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      value = value.replace(/\.(\d{3})(\d)/, '.$1/$2');
      value = value.replace(/(\d{4})(\d)/, '$1-$2');
      input.value = value;
      this.formData.contract.cnpj = value;
    }
  }

  applyCPFMask(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');
    if (value.length <= 11) {
      value = value.replace(/(\d{3})(\d)/, '$1.$2');
      value = value.replace(/(\d{3})(\d)/, '$1.$2');
      value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      input.value = value;
      this.formData.staff.cpf = value;
    }
  }

  applyRGMask(event: Event): void {
    const input = event.target as HTMLInputElement;
    // Permite digitos e letra verificadora (ex.: 12.345.678-X)
    const normalized = (input.value || '').toUpperCase().replace(/[^0-9A-Z]/g, '');
    const digits = normalized.replace(/[A-Z]/g, '').slice(0, 8);
    const verifier = normalized.slice(digits.length, digits.length + 1);

    let formattedValue = digits;
    if (digits.length > 2) {
      formattedValue = `${digits.substring(0, 2)}.${digits.substring(2)}`;
    }
    if (digits.length > 5) {
      formattedValue = `${digits.substring(0, 2)}.${digits.substring(2, 5)}.${digits.substring(5)}`;
    }
    if (verifier) {
      formattedValue += `-${verifier}`;
    }

    input.value = formattedValue;
    this.formData.staff.rg = formattedValue;
  }

  private isCPFValid(cpf: string): boolean {
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11) return false;
    if (/^(\d)\1+$/.test(cpf)) return false;
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let remainder = sum % 11;
    let digit1 = remainder < 2 ? 0 : 11 - remainder;
    sum = 0;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cpf.charAt(i)) * (11 - i);
    }
    remainder = sum % 11;
    let digit2 = remainder < 2 ? 0 : 11 - remainder;
    return parseInt(cpf.charAt(9)) === digit1 && parseInt(cpf.charAt(10)) === digit2;
  }

  validateCPF(cpf: string): boolean {
    const isValid = this.isCPFValid(cpf);
    this.applyCPFValidationStyle(isValid);
    return isValid;
  }

  validateRG(rg: string): boolean {
    const valor = rg.trim();
    const RG_REGEX = /^\d{1,2}\.?\d{3}\.?\d{3}-?[0-9Xx]?$/;
    const RG_REGEX_COM_UF = /^\d{1,2}\.?\d{3}\.?\d{3}-?[0-9Xx]?(?:\s*(?:SSP-)?[A-Z]{2})?$/;
    return RG_REGEX.test(valor) || RG_REGEX_COM_UF.test(valor);
  }

  private applyCPFValidationStyle(isValid: boolean): void {
    const cpfInput = document.querySelector('input[placeholder*="000.000.000-00"]') as HTMLInputElement;
    if (cpfInput) {
      cpfInput.classList.remove('cpf-valid', 'cpf-invalid');
      cpfInput.classList.add(isValid ? 'cpf-valid' : 'cpf-invalid');
    }
  }

  onWorkStartChange(startTime: string): void {
    const detectedShift = this.detectShiftFromTime(startTime);
    this.formData.staff.shift = detectedShift;
    this.calculateWorkSchedule(startTime);
  }

  detectShiftFromTime(startTime: string): string {
    const startHour = parseInt(startTime);
    return (startHour >= 6 && startHour < 18) ? 'Diurno' : 'Noturno';
  }

  calculateWorkSchedule(startTime: string): void {
    const contractType = this.formData.contract?.contractType || 'CLT';
    const startHour = parseInt(startTime);
    let workHours = 8;
    let lunchHours = 1;
    if (contractType === 'Estagiário') {
      workHours = 6;
      lunchHours = 0;
    }
    const isNightShift = startHour >= 18 || startHour <= 5;
    if (isNightShift) {
      lunchHours = 0;
    }
    const totalHours = workHours + lunchHours;
    let endHour = startHour + totalHours;
    if (endHour >= 24) {
      endHour = endHour - 24;
    }
    const endTime = endHour.toString().padStart(2, '0') + ':00';
    this.formData.staff.workSchedule = `${startTime}-${endTime}`;
  }

  getWorkStartTime(): string {
    const schedule = this.formData.staff.workSchedule;
    return schedule.includes('-') ? schedule.split('-')[0] : schedule;
  }

  getWorkEndTime(): string {
    const schedule = this.formData.staff.workSchedule;
    return schedule.includes('-') ? schedule.split('-')[1] : '17:00';
  }

  getWorkHours(): number {
    const contractType = this.formData.contract?.contractType;
    const startTime = this.getWorkStartTime();
    const startHour = parseInt(startTime);
    if (contractType === 'Estagiário') return 6;
    return (startHour >= 18 || startHour <= 5) ? 8 : 9;
  }

  onWorkEndChange(newEndTime: string): void {
    const startTime = this.getWorkStartTime() || '08:00';
    const endTime = newEndTime || '17:00';
    this.formData.staff.workSchedule = `${startTime}-${endTime}`;
  }

  onFileSelected(event: any, documentType: string): void {
    const input = event.target;
    if (!input || !input.files || input.files.length === 0) return;
    const file = input.files[0];
    this.uploadStatus[documentType] = 'pending';
    this.uploadProgress[documentType] = 0;
    if (file.type.startsWith('image/')) {
      this.createImagePreview(file, documentType);
    }
    this.uploadedDocuments[documentType] = {
      ...this.uploadedDocuments[documentType],
      file: file,
      fileName: file.name,
      fileSize: file.size,
      mimeType: file.type,
      uploaded: false,
      uploadDate: null,
      serverFileName: null,
      status: 'Pendente'
    };
    this.addDocumentToAttachments(documentType, file);
    this.updateTabsCompletionStatus();
  }

  private createImagePreview(file: File, documentType: string): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      if (this.uploadedDocuments[documentType]) {
        this.uploadedDocuments[documentType] = {
          ...this.uploadedDocuments[documentType],
          preview: e.target.result
        };
      }
    };
    reader.readAsDataURL(file);
  }

  async uploadDocumentToBackend(documentType: string): Promise<void> {
    const document = this.uploadedDocuments[documentType];
    if (!document || !document.file) return;
    try {
      this.uploadStatus[documentType] = 'uploading';
      this.uploadProgress[documentType] = 0;
      const staffId = 0;
      const docConfig = this.DOCUMENT_TYPES.find(d => d.value === documentType);
      const documentName = docConfig?.label || documentType;
      const response = await this.staffService.uploadDocument(document.file, staffId, documentType.toUpperCase(), documentName).toPromise();
      const blobUrl = response.url || response.Url || response.filePath || response.FilePath || '';
      if (response && response.success) {
        this.uploadStatus[documentType] = 'success';
        this.uploadProgress[documentType] = 100;
        this.uploadedDocuments[documentType] = {
          ...this.uploadedDocuments[documentType],
          uploaded: true,
          uploadDate: response.uploadedAt || response.UploadedAt,
          serverFileName: response.fileName || response.FileName,
          originalFileName: response.originalFileName || response.OriginalFileName,
          url: blobUrl,
          fileSize: response.fileSize || response.FileSize,
          fileExtension: response.fileExtension || response.FileExtension,
          uploadStatus: response.uploadStatus || response.UploadStatus,
          status: 'Aprovado'
        };
        this.addDocumentToAttachments(documentType, document.file, blobUrl);
        this.updateTabsCompletionStatus();
      } else {
        throw new Error(response?.message || 'Upload falhou');
      }
    } catch (error: any) {
      this.uploadStatus[documentType] = 'error';
      this.uploadProgress[documentType] = 0;
    }
  }

  private async uploadDocument(documentType: string, file: File): Promise<void> {
    try {
      this.uploadStatus[documentType] = 'uploading';
      this.uploadProgress[documentType] = 0;
      const progressInterval = setInterval(() => {
        if (this.uploadProgress[documentType] < 90) {
          this.uploadProgress[documentType] += Math.random() * 20;
        }
      }, 200);
      const formData = new FormData();
      formData.append('file', file);
      await new Promise(resolve => setTimeout(resolve, 1500));
      clearInterval(progressInterval);
      this.uploadProgress[documentType] = 100;
      this.uploadStatus[documentType] = 'success';
      this.uploadedDocuments[documentType] = {
        ...this.uploadedDocuments[documentType],
        uploaded: true,
        uploadDate: new Date().toISOString(),
        serverFileName: `staff_${documentType}_${Date.now()}_${file.name}`,
        status: 'Aprovado'
      };
      this.addDocumentToAttachments(documentType, file);
    } catch (error) {
      this.uploadStatus[documentType] = 'error';
      this.uploadProgress[documentType] = 0;
    }
  }

  private addDocumentToAttachments(documentType: string, file: File, blobUrl?: string): void {
    const docType = this.DOCUMENT_TYPES.find(dt => dt.value === documentType);
    const label = docType?.label || documentType;
    const uploadedDoc = this.uploadedDocuments[documentType];
    const filePath = blobUrl || uploadedDoc?.url || uploadedDoc?.Url || '';
    const attachment = {
      documentName: label,
      documentType: documentType,
      status: filePath ? 'Aprovado' : 'Pendente',
      filePath: filePath,
      fileExtension: this.extractExtension(file.name),
      mimeType: file.type,
      fileSize: file.size
    };
    const existingIndex = this.formData.attachments.findIndex(a => a.documentName === label);
    if (existingIndex >= 0) {
      this.formData.attachments[existingIndex] = attachment as any;
    } else {
      this.formData.attachments.push(attachment as any);
    }
    this.updateTabsCompletionStatus();
  }

  async deleteDocument(documentType: string): Promise<void> {
    const document = this.uploadedDocuments[documentType];
    if (!document) return;
    try {
      if (document.uploaded && document.serverFileName) {
        await this.staffService.deleteDocument('1', document.serverFileName).toPromise();
      }
      delete this.uploadedDocuments[documentType];
      delete this.uploadStatus[documentType];
      delete this.uploadProgress[documentType];
      const docType = this.DOCUMENT_TYPES.find(dt => dt.value === documentType);
      const label = docType?.label || documentType;
      this.formData.attachments = this.formData.attachments.filter(a => a.documentName !== label);
      this.updateTabsCompletionStatus();
    } catch (error: any) {}
  }

  isDocumentUploaded(documentType: string): boolean {
    return this.uploadedDocuments[documentType]?.uploaded === true;
  }

  isDocumentUploading(documentType: string): boolean {
    return this.uploadStatus[documentType] === 'uploading';
  }

  onOtherFileSelected(event: any): void {
    const file = event.target?.files?.[0];
    if (!file) return;
    const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();
    const newDoc = {
      file: file,
      documentName: file.name,
      fileSize: file.size,
      fileExtension: fileExtension,
      mimeType: file.type,
      status: 'selecionado',
      uploaded: false,
      url: null
    };
    this.otherDocuments.push(newDoc);
    event.target.value = '';
  }
  
  markOtherDocumentReady(index: number): void {
    const doc = this.otherDocuments[index];
    if (!doc) return;
    doc.status = 'pronto';
    doc.uploaded = true;
    const newAttachment = {
      documentName: doc.documentName,
      documentType: 'other',
      status: 'Pendente',
      filePath: '',
      fileExtension: doc.fileExtension,
      mimeType: doc.mimeType,
      fileSize: doc.fileSize,
      file: doc.file
    };
    this.formData.attachments.push(newAttachment);
    this.updateTabsCompletionStatus();
  }
  
  removeOtherDocument(index: number): void {
    const doc = this.otherDocuments[index];
    if (doc?.uploaded) {
      const attIndex = this.formData.attachments.findIndex(att => 
        att.documentName === doc.documentName && (att as any).documentType === 'other'
      );
      if (attIndex !== -1) {
        this.formData.attachments.splice(attIndex, 1);
      }
    }
    this.otherDocuments.splice(index, 1);
    this.updateTabsCompletionStatus();
  }
  
  formatFileSizeOther(bytes: number): string {
    if (!bytes || bytes === 0) return '-';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  isDocumentError(documentType: string): boolean {
    return this.uploadStatus[documentType] === 'error';
  }

  getUploadProgress(documentType: string): number {
    return this.uploadProgress[documentType] || 0;
  }

  getFileName(documentType: string): string {
    return this.uploadedDocuments[documentType]?.fileName || 'Nenhum arquivo selecionado';
  }

  getFileSize(documentType: string): string {
    const size = this.uploadedDocuments[documentType]?.fileSize || 0;
    if (size === 0) return '';
    const units = ['B', 'KB', 'MB', 'GB'];
    let unitIndex = 0;
    let fileSize = size;
    while (fileSize >= 1024 && unitIndex < units.length - 1) {
      fileSize /= 1024;
      unitIndex++;
    }
    return `${fileSize.toFixed(1)} ${units[unitIndex]}`;
  }

  getUploadedDocumentsCount(): number {
    return Object.values(this.uploadedDocuments).filter(doc => doc?.uploaded === true).length;
  }

  getPendingDocumentsCount(): number {
    return Object.values(this.uploadedDocuments).filter(doc => doc?.uploaded === false).length;
  }

  getDocumentElement(): any {
    return document;
  }

  private extractExtension(filename: string): string {
    const idx = filename.lastIndexOf('.');
    return idx >= 0 ? filename.substring(idx + 1).toLowerCase() : '';
  }

  isTabValid(tabId: string): boolean {
    switch (tabId) {
      case 'basic':
        if (!this.formData.staff.fullName || !this.formData.staff.birthDate) return false;
        if (this.formData.staff.isForeigner) {
          return !!this.formData.staff.passportNumber;
        }
        return !!this.formData.staff.cpf && this.isCPFValid(this.formData.staff.cpf);
      case 'contract':
        const basicContractValid = !!(this.formData.staff.registration && 
                 this.formData.staff.position && 
                 this.formData.staff.department &&
                 this.formData.staff.hireDate &&
                 this.formData.staff.contractType &&
                 this.formData.staff.shift &&
                 this.formData.staff.workSchedule);
        if (this.formData.contract.contractType === 'PJ') {
          return basicContractValid && !!this.formData.contract.cnpj && !!this.formData.contract.companyName;
        }
        return basicContractValid;
      case 'banking':
        return !!(this.formData.staff.bankName && this.formData.staff.agency && this.formData.staff.accountNumber);
      case 'contacts':
        return this.formData.contacts.length > 0 && 
               this.formData.contacts.every(c => !!c.contactType && !!c.contactName && !!c.phoneNumber);
      case 'addresses':
        return this.formData.addresses.length > 0 && 
               this.formData.addresses.every(a => !!a.street && !!a.number && !!a.city && !!a.state && !!a.zipCode);
      case 'salary':
        return !!this.formData.salary && !!this.formData.salary.baseSalary && !!this.formData.salary.salaryType;
      case 'benefits':
        // Para PJ, benefícios são opcionais (pode não ter nenhum).
        if (this.formData.contract?.contractType === 'PJ') {
          return true;
        }
        return !!(this.formData.benefits && this.formData.benefits.length > 0 && 
               this.formData.benefits.some((b: any) => !!b.benefitType && (b.amount ?? 0) > 0));
      case 'documents':
        if (this.formData.attachments.length === 0) return false;
        return this.formData.attachments.every(doc => !!doc.documentName && !!doc.status);
      default:
        return true;
    }
  }

  isTabComplete(tabId: string): boolean {
    switch (tabId) {
      case 'basic':
        return this.isTabValid('basic');
      case 'contract':
        return this.isTabValid('contract');
      case 'banking':
        return !!(this.formData.staff.bankName && this.formData.staff.agency && this.formData.staff.accountNumber);
      case 'contacts':
        return this.formData.contacts.length > 0 && 
               this.formData.contacts.some(c => c.contactName && c.phoneNumber);
      case 'addresses':
        return this.formData.addresses.length > 0 && 
               this.formData.addresses.some(a => a.street && a.number && a.city && a.state);
      case 'salary':
        return !!(this.formData.salary && 
                 ((this.formData.salary.baseSalary ?? 0) > 0 || (this.formData.salary.grossSalary ?? 0) > 0));
      case 'documents':
        if (this.formData.attachments.length === 0) return false;
        return this.formData.attachments.every(doc => !!doc.documentName && !!doc.status);
      default:
        return false;
    }
  }

  updateTabsCompletionStatus(): void {
    this.availableTabs.forEach(tab => {
      tab.completed = this.isTabComplete(tab.id);
    });
  }

  getTabCompletionStatus(tabId: string): boolean {
    const tab = this.availableTabs.find(t => t.id === tabId);
    if (!tab) return false;
    return tab.completed;
  }

  private resetForm(): void {
    this.error = null;
    this.successMessage = null;
    this.activeTab = 'basic';
    this.formData = {
      staff: {
        fullName: '',
        registration: '',
        position: '',
        department: '',
        manager: null,
        hireDate: new Date().toISOString(),
        contractType: 'CLT',
        cpf: '',
        isForeigner: false,
        passportNumber: '',
        rg: '',
        rgIssuingAuthority: '',
        rgIssueDate: '',
        birthDate: '',
        gender: 'Masculino',
        maritalStatus: 'Solteiro',
        motherName: '',
        fatherName: '',
        nationality: 'Brasileira',
        birthPlace: '',
        hasDisability: false,
        bankName: '',
        agency: '',
        accountType: '',
        accountNumber: '',
        accountHolderName: '',
        pixKey: '',
        shift: 'Diurno',
        workSchedule: '08:00-17:00'
      },
      contract: {
        contractType: 'CLT',
        startDate: new Date().toISOString(),
        endDate: null,
        notes: null,
        cnpj: '',
        companyName: '',
        tradeName: '',
        companyAddress: '',
        stateRegistration: '',
        municipalRegistration: '',
        companyEmail: '',
        companyPhone: ''
      },
      addresses: [],
      contacts: [],
      salary: {
        baseSalary: null,
        grossSalary: null,
        netSalary: null,
        currency: 'BRL',
        salaryType: 'Base',
        notes: ''
      } as any,
      benefits: [],
      attachments: []
    };
    this.initializeEmptyContacts();
    this.uploadedDocuments = {};
    this.uploadStatus = {};
    this.uploadProgress = {};
    this.updateTabsCompletionStatus();
  }

  async saveStaff(): Promise<void> {
    if (!this.isFormValid()) {
      this.error = 'Por favor, preencha todos os campos obrigatórios';
      return;
    }
    if (!this.formData.staff.birthDate) {
      this.error = 'Data de nascimento é obrigatória';
      return;
    }
    if (!this.formData.staff.hireDate) {
      this.error = 'Data de contratação é obrigatória';
      return;
    }
    this.saving = true;
    this.error = null;
    this.successMessage = null;
    try {
      const createPayload = this.prepareCreatePayload();
      const result = await this.staffService.createStaffWithDTO(createPayload).toPromise();
      const response = result as any;
      const createdStaff =
        response?.Staff ??
        response?.staff ??
        response?.Data?.Staff ??
        response?.data?.staff ??
        response?.Data ??
        response?.data;

      const createdId =
        createdStaff?.Id ??
        createdStaff?.id ??
        response?.StaffId ??
        response?.staffId ??
        response?.Id ??
        response?.id;

      const hasErrorFlag = response?.success === false || response?.Success === false;
      const hasAnySuccessSignal = Boolean(
        response &&
        !hasErrorFlag &&
        (
          createdId ||
          createdStaff ||
          response?.success === true ||
          response?.Success === true
        )
      );

      if (!hasAnySuccessSignal) {
        let errorMessage = 'Resposta inválida do servidor';
        if (response && typeof response === 'object') {
          if (response?.message) {
            errorMessage = response.message;
          } else if (response?.Message) {
            errorMessage = response.Message;
          } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
            errorMessage = response.errors.map((e: any) => e?.message || e).join('; ');
          }
        }
        throw new Error(errorMessage);
      }

      this.error = null;
      this.successMessage = 'Funcionário cadastrado com sucesso!';
      setTimeout(() => {
        this.router.navigate(['/hr/staff']);
      }, 600);
    } catch (error: any) {
      let friendlyErrorMessage = 'Erro ao cadastrar funcionário';
      if (error instanceof HttpErrorResponse) {
        try {
          const apiError = error.error; // Assume error.error já é o objeto JSON
          if (apiError && typeof apiError === 'object') {
            friendlyErrorMessage = apiError.message || apiError.error || friendlyErrorMessage;
          }
        } catch (parseError) {
          // Fallback if error.error is not a valid JSON object or other unexpected format
          friendlyErrorMessage = error.message || friendlyErrorMessage;
        }
      } else if (error && error.message) {
        friendlyErrorMessage = error.message;
      }
      this.error = friendlyErrorMessage;
      this.successMessage = null;
    } finally {
      this.saving = false;
    }
  }

  private prepareCreatePayload(): any {
    const s = this.formData as any;
    
    const toISO = (date: string | null): string | null => {
      if (!date || date.trim() === '') return null;
      try {
        if (date.includes('T') && date.includes('Z')) return date;
        if (date.includes('/')) {
          const parts = date.split('/');
          if (parts.length === 3) {
            const day = parts[0].padStart(2, '0');
            const month = parts[1].padStart(2, '0');
            const year = parts[2];
            return `${year}-${month}-${day}T00:00:00.000Z`;
          }
        }
        if (date.match(/^\d{4}-\d{2}-\d{2}$/)) {
          return `${date}T00:00:00.000Z`;
        }
        const d = new Date(date);
        if (isNaN(d.getTime())) return null;
        return d.toISOString();
      } catch (error) {
        return null;
      }
    };

    const contacts = (s.contacts || []).map((contact: any) => ({
      contactType: contact.contactType || 'Telefone',
      contactName: contact.contactName || s.staff.fullName,
      phoneNumber: contact.phoneNumber || '',
      relationship: contact.relationship || 'Próprio',
      isEmergencyContact: contact.isEmergencyContact || false,
      isDefault: contact.isDefault || false
    })).filter((c: any) => c.phoneNumber && c.phoneNumber.trim() !== '');

    const addresses = (s.addresses || []).map((addr: any) => ({
      addressType: addr.addressType || 'Residencial',
      street: addr.street || '',
      number: addr.number || '',
      complement: addr.complement || '',
      neighborhood: addr.neighborhood || '',
      city: addr.city || '',
      state: addr.state || '',
      zipCode: addr.zipCode || '',
      country: addr.country || 'Brasil',
      isDefault: addr.isDefault || false
    }));

    const salary = s.salary ? {
      baseSalary: s.salary.baseSalary ?? 0,
      grossSalary: s.salary.grossSalary ?? 0,
      netSalary: s.salary.netSalary ?? 0,
      currency: s.salary.currency || 'BRL',
      salaryType: s.salary.salaryType || 'Mensal',
      effectiveDate: toISO(s.salary.effectiveDate) || toISO(s.staff.hireDate),
      endDate: null,
      notes: s.salary.notes || null,
      reason: 'Admissão',
      isActive: true,
      isCurrent: true
    } : null;

    const benefits = (s.benefits || []).map((benefit: any) => ({
      benefitType: benefit.benefitType || '',
      description: benefit.description || null,
      amount: benefit.amount ?? 0,
      currency: benefit.currency || 'BRL',
      startDate: toISO(benefit.startDate) || new Date().toISOString(),
      endDate: null,
      isActive: benefit.isActive !== undefined ? benefit.isActive : true,
      notes: benefit.notes || null
    })).filter((b: any) => b.benefitType && b.amount > 0);

    const selectedDepartment =
      (this.departments || []).find(d => d.id === this.selectedDepartmentId)
      || (this.departments || []).find(d => d.name === s.staff.department);
    const departmentId = selectedDepartment?.id ?? this.selectedDepartmentId ?? null;
    const managerId = selectedDepartment?.managerStaffId ?? null;

    let positionId: number | null = null;
    if (s.staff.position && this.positions && this.positions.length > 0) {
      const selectedPosition = this.positions.find(p => p.name === s.staff.position);
      positionId = selectedPosition ? selectedPosition.id : null;
    }

    const selectedCostCenter = (this.costCenters || []).find(cc => cc.code === (s.contract?.costCenter || ''));
    const costCenterId = selectedCostCenter?.id ?? null;

    return {
      staff: {
        fullName: s.staff.fullName || '',
        registration: s.staff.registration || '',
        departmentId: departmentId,
        DepartmentId: departmentId,
        positionId: positionId,
        PositionId: positionId,
        costCenterId: costCenterId,
        CostCenterId: costCenterId,
        managerId: managerId,
        ManagerId: managerId,
        position: s.staff.position || '',
        department: s.staff.department || '',
        manager: s.staff.manager || null,
        costCenter: s.contract?.costCenter || null,
        hireDate: toISO(s.staff.hireDate) || new Date().toISOString(),
        terminationDate: toISO(s.contract?.endDate) || null,
        contractType: s.contract?.contractType || s.staff.contractType || 'CLT',
        cnpj: s.contract?.contractType === 'PJ' ? (s.contract.cnpj || null) : null,
        companyName: s.contract?.contractType === 'PJ' ? (s.contract.companyName || null) : null,
        tradeName: s.contract?.contractType === 'PJ' ? (s.contract.tradeName || null) : null,
        companyAddress: s.contract?.contractType === 'PJ' ? (s.contract.companyAddress || null) : null,
        stateRegistration: s.contract?.contractType === 'PJ' ? (s.contract.stateRegistration || null) : null,
        municipalRegistration: s.contract?.contractType === 'PJ' ? (s.contract.municipalRegistration || null) : null,
        companyEmail: s.contract?.contractType === 'PJ' ? (s.contract.companyEmail || null) : null,
        companyPhone: s.contract?.contractType === 'PJ' ? (s.contract.companyPhone || null) : null,
        inactive: s.staff.inactive || false,
        blocked: s.staff.blocked || false,
        client: s.staff.client || false,
        blockPeriod: toISO(s.staff.blockPeriod) || null,
        shift: s.staff.shift || 'Manhã',
        workSchedule: s.staff.workSchedule || '08:00 às 18:00',
        unit: s.staff.unit || null,
        isForeigner: s.staff.isForeigner || false,
        cpf: s.staff.isForeigner ? null : (s.staff.cpf || ''),
        passportNumber: s.staff.isForeigner ? (s.staff.passportNumber || null) : null,
        rg: s.staff.rg || null,
        rgIssuingAuthority: s.staff.rgIssuingAuthority || null,
        rgIssueDate: toISO(s.staff.rgIssueDate) || null,
        birthDate: toISO(s.staff.birthDate) || new Date().toISOString(),
        gender: s.staff.gender || 'Masculino',
        maritalStatus: s.staff.maritalStatus || 'Solteiro',
        motherName: s.staff.motherName || '',
        fatherName: s.staff.fatherName || '',
        nationality: s.staff.nationality || 'Brasileiro',
        birthPlace: s.staff.birthPlace || '',
        hasDisability: !!s.staff.hasDisability,
        bankName: s.staff.bankName || null,
        agency: s.staff.agency || null,
        accountType: s.staff.accountType || null,
        accountNumber: s.staff.accountNumber || null,
        accountHolderName: s.staff.accountHolderName || s.staff.fullName,
        pixKey: s.staff.pixKey || null
      },
      addresses: addresses,
      contacts: contacts,
      salary: salary,
      benefits: benefits,
      attachments: this.prepareAttachmentsForDatabase()
    };
  }

  private prepareAttachmentsForDatabase(): any[] {
    const attachments: any[] = [];
    Object.keys(this.uploadedDocuments).forEach(documentType => {
      const document = this.uploadedDocuments[documentType];
      if (document && document.uploaded && document.url) {
        const docType = this.DOCUMENT_TYPES.find(dt => dt.value === documentType);
        const documentName = document.documentName || docType?.label || documentType;
        const attachment = {
          staffId: 0,
          documentName: documentName,
          status: document.status || 'Aprovado',
          filePath: document.url,
          fileExtension: document.fileExtension || this.getFileExtension(document.originalFileName || document.fileName || ''),
          mimeType: document.mimeType || this.getMimeType(document.fileExtension || ''),
          fileSize: document.fileSize || 0
        };
        attachments.push(attachment);
      }
    });
    return attachments;
  }

  private getFileExtension(fileName: string): string {
    if (!fileName) return '';
    const lastDot = fileName.lastIndexOf('.');
    return lastDot > 0 ? fileName.substring(lastDot) : '';
  }

  private getMimeType(extension: string): string {
    const mimeTypes: { [key: string]: string } = {
      '.pdf': 'application/pdf',
      '.jpg': 'image/jpeg',
      '.jpeg': 'image/jpeg',
      '.png': 'image/png',
      '.gif': 'image/gif',
      '.doc': 'application/msword',
      '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      '.xls': 'application/vnd.ms-excel',
      '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      '.txt': 'text/plain'
    };
    return mimeTypes[extension.toLowerCase()] || 'application/octet-stream';
  }

  isFormValid(): boolean {
    return this.isTabValid('basic') && this.isTabValid('contract');
  }

  backToList(): void {
    this.router.navigate(['/hr/staff']);
  }

  async consultarCEP(cep: string, addressIndex: number = 0): Promise<void> {
    if (!cep || cep.length < 8) return;
    const cepLimpo = cep.replace(/\D/g, '');
    if (cepLimpo.length !== 8) return;
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      const data = await response.json();
      if (data.erro) return;
      if (this.formData?.addresses && this.formData.addresses[addressIndex]) {
        this.formData.addresses[addressIndex].street = data.logradouro || '';
        this.formData.addresses[addressIndex].neighborhood = data.bairro || '';
        this.formData.addresses[addressIndex].city = data.localidade || '';
        this.formData.addresses[addressIndex].state = data.uf || '';
        this.formData.addresses[addressIndex].country = 'Brasil';
        this.cdr.detectChanges();
      }
    } catch (error) {}
  }
}

interface StaffDTO {
  FullName: string; Registration: string; Position: string; Department: string;
  Manager: string | null; CostCenter: string | null; HireDate: string | null; TerminationDate: string | null;
  ContractType: string | null; Inactive: boolean; Blocked: boolean; Client: boolean; BlockPeriod: string | null;
  Shift: string | null; WorkSchedule: string | null; Unit: string | null;
  IsForeigner: boolean; CPF: string | null; PassportNumber: string | null; RG: string | null;
  RGIssuingAuthority: string | null; RGIssueDate: string | null; BirthDate: string | null; Gender: string | null;
  MaritalStatus: string | null; MotherName: string | null; FatherName: string | null; Nationality: string | null; BirthPlace: string | null; HasDisability: boolean;
  BankName: string | null; Agency: string | null; AccountType: string | null; AccountNumber: string | null; AccountHolderName: string | null; PIXKey: string | null;
  Addresses: any[]; Contacts: any[]; SalaryHistory: any[]; Attachments: any[]; User: any | null;
}

export interface StaffFormComponent {
  toStaffDTO: () => StaffDTO;
}

(StaffFormComponent as any).prototype.toStaffDTO = function(this: StaffFormComponent): StaffDTO {
  const s = (this as any).formData as any;
  
  const iso = (d?: string | null) => {
    if (!d) return null;
    try {
      if (d.includes('T') && d.includes('Z')) return d;
      if (d.match(/^\d{4}-\d{2}-\d{2}$/)) {
        const date = new Date(d + 'T00:00:00.000Z');
        if (isNaN(date.getTime())) return null;
        return date.toISOString();
      }
      const date = new Date(d);
      if (isNaN(date.getTime())) return null;
      return date.toISOString();
    } catch (error) {
      return null;
    }
  };

  return {
    FullName: s?.staff?.fullName ?? '',
    Registration: s?.staff?.registration ?? '',
    Position: s?.staff?.position ?? '',
    Department: s?.staff?.department ?? '',
    Manager: s?.staff?.manager ?? null,
    CostCenter: s?.contract?.costCenter ?? null,
    HireDate: iso(s?.staff?.hireDate ?? null),
    TerminationDate: iso(s?.contract?.endDate ?? null),
    ContractType: s?.contract?.contractType ?? s?.staff?.contractType ?? null,
    Inactive: !!s?.staff?.inactive,
    Blocked: !!s?.staff?.blocked,
    Client: !!s?.staff?.client,
    BlockPeriod: iso(s?.staff?.blockPeriod ?? null),
    Shift: s?.staff?.shift ?? null,
    WorkSchedule: s?.staff?.workSchedule ?? null,
    Unit: s?.staff?.unit ?? null,
    IsForeigner: !!s?.staff?.isForeigner,
    CPF: s?.staff?.cpf ?? null,
    PassportNumber: s?.staff?.passportNumber ?? null,
    RG: s?.staff?.rg ?? null,
    RGIssuingAuthority: s?.staff?.rgIssuingAuthority ?? null,
    RGIssueDate: iso(s?.staff?.rgIssueDate ?? null),
    BirthDate: iso(s?.staff?.birthDate ?? null),
    Gender: s?.staff?.gender ?? null,
    MaritalStatus: s?.staff?.maritalStatus ?? null,
    MotherName: s?.staff?.motherName ?? null,
    FatherName: s?.staff?.fatherName ?? null,
    Nationality: s?.staff?.nationality ?? null,
    BirthPlace: s?.staff?.birthPlace ?? null,
    HasDisability: !!s?.staff?.hasDisability,
    BankName: s?.staff?.bankName ?? null,
    Agency: s?.staff?.agency ?? null,
    AccountType: s?.staff?.accountType ?? null,
    AccountNumber: s?.staff?.accountNumber ?? null,
    AccountHolderName: s?.staff?.accountHolderName ?? null,
    PIXKey: s?.staff?.pixKey ?? null,
    Addresses: s?.addresses ?? [],
    Contacts: s?.contacts ?? [],
    SalaryHistory: s?.salaryHistory ?? [],
    Attachments: (s?.attachments ?? []).map((a: any) => ({ ...a })),
    User: null
  } as StaffDTO;
};
